import api from "../../components/commonComponents/axiosSetup";
import { BASE_URL } from "../../config";

export const fetchTickets = async () => {
  try {
    const response = await api.get(`${BASE_URL}tickets/getAll`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const createTicket = async (payload) => {
  try {
    const response = await api.post(`${BASE_URL}tickets/create`, payload);
    return response;
  } catch (error) {
    console.error("Error creating ticket:", error);
    throw error; // re-throw so caller can handle
  }
};

export const updateTicket = async (payload) => {
  try {
    const response = await api.put(`${BASE_URL}tickets/update/status`, payload);
    return response;
  } catch (error) {
    console.log(error);
  }
};
